// Callback lock to prevent multiple simultaneous function calls

import { useCallback, useState } from 'react'

function useLock (handler) {
  const [locked, setLocked] = useState(false)
  const handleLock = useCallback(async (...args) => {
    if (locked) {
      return
    }

    setLocked(true)
    const result = await handler(...args)
    setLocked(false)

    return result
  }, [handler, locked])

  return [handleLock, locked]
}

export default useLock
